import {
  get as getArticles,
  getPlaceholderTilesArticle,
} from 'services/tiles-article'

export const SET_TILES_ARTICLE_DATA = 'SET_TILES_ARTICLE_DATA'
export const SET_TILES_ARTICLE_PROCESSING = 'SET_TILES_ARTICLE_PROCESSING'
export const SET_TILES_ARTICLE_DATA_PLACEHOLDERS =
  'SET_TILES_ARTICLE_DATA_PLACEHOLDERS'
export const SET_TILES_ARTICLE_QUERY = 'SET_TILES_ARTICLE_QUERY'
export const APPEND_TILES_ARTICLE_DATA = 'APPEND_TILES_ARTICLE_DATA'
export const APPEND_TILES_ARTICLE_DATA_PLACEHOLDERS =
  'APPEND_TILES_ARTICLE_DATA_PLACEHOLDERS'
export const SET_TILES_ARTICLE_DATE_TIME_TEXT =
  'SET_TILES_ARTICLE_DATE_TIME_TEXT'

const DEFAULT_TILES_ARTICLE_PLACEHOLDER_SIZE = 3

export function getTilesArticlesData (
  locale,
  page,
  limit,
  location,
  updateData,
) {
  return function getTilesArticlesDataThunk (dispatch) {
    const query = location ? location.query : null
    dispatch(setTilesArticleQuery(query))
    if (updateData) {
      dispatch(
        appendTilesArticleDataPlaceholders(
          DEFAULT_TILES_ARTICLE_PLACEHOLDER_SIZE,
        ),
      )
    } else {
      dispatch(
        setTilesArticleDataPlaceholders(DEFAULT_TILES_ARTICLE_PLACEHOLDER_SIZE),
      )
    }
    return getArticles({ locale, page, limit }).then((data) => {
      if (updateData) {
        dispatch(appendTilesArticleData(data.articles, data.currentPage))
      } else {
        dispatch(setTilesArticleData(data))
      }
      return data
    })
  }
}

export function setTilesArticleData (data, processing = false) {
  return {
    type: SET_TILES_ARTICLE_DATA,
    payload: { data, processing },
  }
}

export function appendTilesArticleData (
  articles,
  currentPage,
  processing = false,
  filterPlaceholders = true,
) {
  return {
    type: APPEND_TILES_ARTICLE_DATA,
    payload: { articles, currentPage, processing, filterPlaceholders },
  }
}

export function setTilesArticleProcessing (value) {
  return {
    type: SET_TILES_ARTICLE_PROCESSING,
    payload: value,
  }
}

export function setTilesArticleDataPlaceholders (
  data = DEFAULT_TILES_ARTICLE_PLACEHOLDER_SIZE,
) {
  return {
    type: SET_TILES_ARTICLE_DATA_PLACEHOLDERS,
    payload: typeof data === 'number' ? getPlaceholderTilesArticle(data) : data,
  }
}

export function appendTilesArticleDataPlaceholders (
  data = DEFAULT_TILES_ARTICLE_PLACEHOLDER_SIZE,
) {
  return {
    type: APPEND_TILES_ARTICLE_DATA_PLACEHOLDERS,
    payload: typeof data === 'number' ? getPlaceholderTilesArticle(data) : data,
  }
}

export function setTilesArticleQuery (query, processing = true) {
  return {
    type: SET_TILES_ARTICLE_QUERY,
    payload: { query, processing },
  }
}

export function setTilesArticleDateTimeText (value) {
  return {
    type: SET_TILES_ARTICLE_DATE_TIME_TEXT,
    payload: value,
  }
}
